'use strict';

const productConfiguratorStore = {
    init: (VueX) => {
        const state = {
            snapshots: [],
            footerMode: 'partsFooter',
            fragranceLabel: 'Imperial Rose',
            selectedProductPart: 0,
            savedProductParts: [],
            productLayers: '0-0-0||1-0-0||2-0-0||3-0-0',
            productParts: [],
            resources: {},
            productId: null,
            upsellData: null
        };

        const getters = {
            snapshots: state => state.snapshots,
            footerMode: state => state.footerMode,
            fragranceLabel: state => state.fragranceLabel,
            selectedProductPart: state => state.selectedProductPart,
            savedProductParts: state => state.savedProductParts,
            productLayers: state => state.productLayers.split('||'),
            productParts: state => state.productParts,
            statusMessages: state => state.resources.statusMessages,
            resources: state => state.resources,
            resourceGlobal: state => state.resources.global,
            resourceIntroMessage: state => state.resources.introMessage,
            resourceStatusMessages: state => state.resources.statusMessages,
            resourceProductParts: state => state.resources.productParts,
            resourcePartsFooter: state => state.resources.partsFooter,
            categories: state => state.categories,
            currentProductPart: state => state.productParts[state.selectedProductPart],
            upsellData: state => state.upsellData,
            productId: state => state.productId
        };

        const mutations = {
            addSnapshot(state) {
                state.snapshots.push(state.productLayers);
            },

            useSnapshot(state) {
                state.productLayers = state.snapshots.pop();
            },

            popSnapshot(state) {
                state.snapshots.pop();
            },

            setFooterMode(state, newVal) {
                state.footerMode = newVal;
            },

            setFragranceLabel(state, newVal) {
                state.fragranceLabel = newVal;
            },

            setProductLayers(state, newVal) {
                state.productLayers = newVal.join('||');
            },

            setUpsellData(state, newVal) {
                state.upsellData = newVal;
            },

            setSelectedProductPart(state, newVal) {
                state.selectedProductPart = newVal;
            },

            confirmProductPartSelected(state) {
                if (state.selectedProductPart !== null &&
                    state.selectedProductPart != undefined &&
                    !state.savedProductParts.includes(state.selectedProductPart)) {
                    state.savedProductParts.push(state.selectedProductPart);
                }
            },

            setProductParts(state, newVal) {
                if (!state.productParts) {
                    state.productParts = newVal;
                    return;
                }
                const Vue = require('vue');
                Vue.set(state, 'productParts', newVal);
                state.productParts = newVal;
            },

            setProductId(state, newVal) {
                state.productId = newVal;
            },

            setResources(state, newVal) {
                state.resources = newVal;
            }
        };

        return new VueX.Store({
            state: state,
            getters: getters,
            mutations: mutations
        });
    }
};

module.exports = productConfiguratorStore;
